import {CUSTOMER_SERVICE_URL} from './urls';

function getCustomerServices() {
	return window.axios.get(CUSTOMER_SERVICE_URL);
}

export default getCustomerServices;



// WEBPACK FOOTER //
// ../source/common/api/get-customer-service.js